export let RelationshipStatus = /*#__PURE__*/function (RelationshipStatus) {
  RelationshipStatus["Pending"] = "pending";
  RelationshipStatus["Approved"] = "approved";
  RelationshipStatus["Canceled"] = "canceled";
  RelationshipStatus["Terminated"] = "terminated";
  RelationshipStatus["Expired"] = "expired";
  return RelationshipStatus;
}({});
export let RelationshipProgressStatus = /*#__PURE__*/function (RelationshipProgressStatus) {
  RelationshipProgressStatus["Sent"] = "sent";
  RelationshipProgressStatus["Reviewed"] = "reviewed";
  RelationshipProgressStatus["MicroDeposit"] = "microDeposit";
  RelationshipProgressStatus["PaymentMethod"] = "paymentMethod";
  RelationshipProgressStatus["Approved"] = "approved";
  RelationshipProgressStatus["MicroDepositFailed"] = "microDepositFailed";
  RelationshipProgressStatus["Expired"] = "expired";
  return RelationshipProgressStatus;
}({});

// eslint-disable-next-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any